import { createRoot } from 'react-dom/client'
import { Provider } from 'react-redux'

import { store } from '~/shared/store/store'

import { App } from './App'
import './app.css'
import './lib/i18n/i18n'

createRoot(document.getElementById('root') as HTMLElement).render(
  <Provider store={store}>
    <App />
  </Provider>,
)
